// extracted by mini-css-extract-plugin
module.exports = {"root":"Explainer_root__3dXq-","title":"Explainer_title__3T0vx","body":"Explainer_body__UHR1S"};